import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./hooks/useCart";
import { AuthProvider } from "./hooks/useAuth";
import { OrdersProvider } from "./hooks/useOrders";
import { FavoritesProvider } from "./hooks/useFavorites";
import { RewardsProvider } from "./hooks/useRewards";
import CartDrawer from "./components/feature/CartDrawer";
import { useDesignSystem } from "./hooks/useDesignSystem";

/** Applies design settings (colors, fonts, radius, etc.) to the DOM globally */
function DesignSystemProvider({ children }: { children: React.ReactNode }) {
  useDesignSystem();
  return <>{children}</>;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <OrdersProvider>
            <RewardsProvider>
              <FavoritesProvider>
                <CartProvider>
                  <DesignSystemProvider>
                    <AppRoutes />
                    <CartDrawer />
                  </DesignSystemProvider>
                </CartProvider>
              </FavoritesProvider>
            </RewardsProvider>
          </OrdersProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
